import { Component, OnInit } from '@angular/core';
import { NewEnvelopeService } from 'src/app/envelope/new-envelope/new-envelope.service';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { Authorizer } from '../../../model/authorizer';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { AuthService } from 'src/app/services/auth.service';
import { IToast, ToastService } from 'codex-lib';
import { TranslateService } from '@ngx-translate/core';
import { SurvicateService } from 'src/app/services/survicate.service';
import { MainEnvelopeComponent } from 'src/app/main-envelope/main-envelope.component';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';

@Component({
  selector: 'app-authorizer-information',
  templateUrl: './authorizer-information.component.html',
  styleUrls: ['./authorizer-information.component.scss']
})
export class AuthorizerInformationComponent implements OnInit {

  authorizerInformation: any;
  reminderFrequency: string;
  blankSlateSearch: any;
  valueSearch: string;
  settings: any;
  canSendWhatsApp: boolean = false;
  isSignFreemium: boolean = false;
  filteredAuthorizers: Array<Authorizer>;
  isSendWhatsapp: boolean = false;

  constructor(
    private newEnvelopeService: NewEnvelopeService,
    private authService: AuthService,
    private translateService: TranslateService,
    private survicateService: SurvicateService,
    private toastService: ToastService,
    private mainEnvelopeComponent: MainEnvelopeComponent,
    private googleAnalitycsService: AnalyticsService) {
    this.filteredAuthorizers = new Array<Authorizer>();

    if (!this.authService.signUserModel) {
      return;
    }
    this.canSendWhatsApp = this.authService.signUserModel.sendWhatsapp;
  }

  ngOnInit() {
    this.canSendWhatsApp = this.mainEnvelopeComponent.canSendWhatsApp;
    this.isSendWhatsapp = this.mainEnvelopeComponent.isSendWhatsapp;
    this.isSignFreemium = this.survicateService.isSignFree();
    this.authorizerInformation = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory);
    this.authorizerInformation['envelopeAuthorizers']
      .forEach(e => {
        e.ssnWithMask = e.ssn ? CPFCNPJUtil.obfuscateCpfCnpj(CPFCNPJUtil.formatSsn(e.ssn)) : '';
        e.sendWhatsApp = false;
      });
    this.settings = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Settings).value;

    this.filteredAuthorizers = this.authorizerInformation['envelopeAuthorizers'];

    this.blankSlateSearch = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus'
      },
      buttonText: 'cleanSearch'
    };
  }

  onSearch(textToSearch) {
    this.valueSearch = textToSearch;
    if (textToSearch) {
      this.filteredAuthorizers = this.authorizerInformation['envelopeAuthorizers'].filter(item =>
        Object.keys(item).some(
          k =>
            item[k] != null &&
            item[k]
              .toString()
              .toLowerCase()
              .includes(textToSearch.toLowerCase())
        )
      );
    } else {
      this.filteredAuthorizers = this.authorizerInformation['envelopeAuthorizers'];
    }
  }

  onBlankSlateSearchClick = () => this.onSearch('');

  needSendWhatsapp = (event: boolean, authorizer: Authorizer) => {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_Revisar_WA_Aprovadores',
        event ? 'Ativo' : 'Inativo'
      )
    );

    authorizer.sendWhatsApp = event;
  }

  toastWhatsFree() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.acceptWhatsappSignFreeToast'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }

  handleToggleClick(event: Event) {
    if (!this.canSendWhatsApp && !this.isSignFreemium) {
      event.preventDefault();
      event.stopPropagation();
      this.toastCantSendWhatsapp();
    }
  }

  toastCantSendWhatsapp() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.sendMessageWhatsappDisabled'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }
}
